module.exports = __webpack_public_path__ + "static/img/rest71.d98b35c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest71.jpg
// module id = 8EDk
// module chunks = 0